import pako from 'pako';

const PAKO_PREFIX = 'pako:';

function _compress(str) {
  const compressed = pako.deflate(str);
  let binary = '';
  for (let i = 0; i < compressed.length; i++) {
    binary += String.fromCharCode(compressed[i]);
  }
  return PAKO_PREFIX + btoa(binary);
}

function _decompress(value) {
  if (!value.startsWith(PAKO_PREFIX)) return value;
  const binary = atob(value.slice(PAKO_PREFIX.length));
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return pako.inflate(bytes, { to: 'string' });
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

function setCompressedCookie(cname, cvalue, exdays) {
  const str = typeof cvalue === 'string' ? cvalue : JSON.stringify(cvalue);
  const compressed = _compress(str);
  var d = new Date();
  d.setTime(d.getTime() + ((exdays || 1) * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + encodeURIComponent(compressed) + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            const raw = c.substring(name.length, c.length);
            if (raw.startsWith(PAKO_PREFIX)) {
              return _decompress(raw);
            }
            return raw;
        }
    }
    return "";
  }

  function deleteCookie(cname) {
    document.cookie = cname+"=;path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
  }




const getCookieV3 = (name) => {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    let [key, value] = cookie.split("=");
    if (key === name) {
      return JSON.parse(decodeURIComponent(value)); // Convert string back to object
    }
  }
  return null;
};
 const setCookieV3 = (cname, cvalue, exdays, domain) => {
  if (!domain) {
    domain = window.location.hostname.includes("localhost") ? "" : window.location.hostname;
  } else if (window.location.hostname.includes("localhost")) {
    domain = "";
  }
  let d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = `expires=${d.toUTCString()}`;
  let cookieString = `${cname}=${encodeURIComponent(cvalue)}; ${expires}; path=/`;
  if (domain) {
    cookieString += `; domain=${domain}`;
  }
  // Optional: Secure cookies on HTTPS
  if (window.location.protocol === "https:") {
    cookieString += "; Secure; SameSite=Lax";
  }
  document.cookie = cookieString;
};


export const getChangeToken = ()=> {
  return getCookie('change-token')  || "";
}

  export {getCookie, setCookie, setCompressedCookie, deleteCookie,
    getCookieV3,
    setCookieV3
  };
